// PaperReelForm.jsx
import React from 'react';
import { Grid, TextField } from '@mui/material';

const PaperReelForm = ({ formData, handleChange }) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <TextField
        label="Width"
        name="width"
        fullWidth
        value={formData.width || ''}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        label="Diameter"
        name="diameter"
        fullWidth
        value={formData.diameter || ''}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        label="Weight (kg)"
        name="weight_kg"
        fullWidth
        value={formData.weight_kg || ''}
        onChange={handleChange}
      />
    </Grid>
  </Grid>
);

export default PaperReelForm;
